import React from "react";
import {
  Box,
  Grid,
  Typography,
  Skeleton,
  Divider,
} from "@mui/material";

const Field = ({ label, value, loading }) => (
  <Grid item xs={12} sm={6} md={4}>
    <Typography variant="caption" color="text.secondary" display="block">
      {label}
    </Typography>
    {loading ? (
      <Skeleton width="60%" />
    ) : (
      <Typography variant="body1" fontWeight={500}>
        {value || "—"}
      </Typography>
    )}
  </Grid>
);

const formatDate = (val) => {
  if (!val) return null;
  const d = new Date(val);
  return `${d.toLocaleDateString("en-US", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  })}  ${d.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" })}`;
};

const VehicleModelDetailsTab = ({ modelData, isLoading }) => {
  return (
    <Box sx={{ pt: 3 }}>
      <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 2 }}>
        Model Details
      </Typography>
      <Divider sx={{ mb: 3 }} />
      <Grid container spacing={3}>
        <Field label="Model Name"   value={modelData?.name}      loading={isLoading} />
        <Field label="Model Year"   value={modelData?.modelYear}  loading={isLoading} />
        <Field label="Region"       value={modelData?.region}     loading={isLoading} />
        <Field label="Created By"   value={modelData?.createdBy}  loading={isLoading} />
        <Field label="Created Date" value={formatDate(modelData?.createdAt)} loading={isLoading} />
        <Field label="Updated By"   value={modelData?.updatedBy}  loading={isLoading} />
        <Field label="Updated Date" value={formatDate(modelData?.updatedAt)} loading={isLoading} />
      </Grid>
    </Box>
  );
};

export default VehicleModelDetailsTab;